import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';
import { NewsPredefinedTranslation } from '../../../../models/news/news-predefined-translation.model';

@Component({
  selector: 'app-news-predefined-translation-edit-modal',
  templateUrl: './news-predefined-translation-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class NewsPredefinedTranslationEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  newsPredefinedId: number = 0;
  languageId: number = 0;
  languageIso: string = '';
  title: string = '';
  summary: string = '';
  content: string = '';
  linkButtonName: string = '';

  private callbackSaved?: () => void;

  constructor(private apiNewsService: ApiNewsService, private alertsService: AlertsService) {}

  show(newsPredefinedId: number, languageIso: string, translation: NewsPredefinedTranslation, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.newsPredefinedId = newsPredefinedId;
    this.languageId = translation.languageId;
    this.languageIso = languageIso;
    this.title = translation.title;
    this.summary = translation.summary;
    this.content = translation.content;
    this.linkButtonName = translation.linkButtonName ?? '';
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiNewsService.editNewsPredefinedTranslation(this.newsPredefinedId, this.languageId, this.title, this.summary, this.content, this.linkButtonName).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Translation updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating translation : ' + error);
      }
    );
  }
}
